import styled from 'styled-components';

import { globalTheme } from '@cld/component-theme';

import { FieldSize } from '../FieldSize';

export interface DecorationWrapperProps {
  size: FieldSize;
}

export const DecorationWrapper = styled.div<DecorationWrapperProps>`
  align-items: center;
  display: flex;
  line-height: 1;

  &:first-child {
    padding-left: ${globalTheme.spacing.xs};
  }

  &:last-child {
    padding-right: ${globalTheme.spacing.xs};
  }
`;
